var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-2 mb-2",style:(_vm.styleObj)},[_c('e-charts',{staticStyle:{"height":"20rem","width":"100%"},attrs:{"option":_vm.option,"theme":"theme-color","auto-resize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }